import BaseUseCase from "../base_use_case.js";

class CompleteRegistrationInfoUseCase extends BaseUseCase {

  execute(token) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/registrations/complete`,
      params: {confirmationToken: token}
    });
  }
}

const instance = new CompleteRegistrationInfoUseCase();
export default instance;